module.exports = __webpack_public_path__ + "img/forgetpass.d695f48f.png";